export enum PaymentQrcStatusType {
    Created = 'Created',
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Succeed = 'Succeed',
    Failed = 'Failed'
}
